import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { List, ListItem } from '@mui/material';
import FrmDialogTest1 from './FrmDialogTest1';
type Props = {};
const FrmDialogTest: React.FC<Props> = () => {
    const [open, setOpen] = useState(false); // dialog開關
    const [selectedProfession, setSelectedProfession] = useState<string>(""); // 新增選擇職業的狀態
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <div>
            <Button variant="outlined" onClick={handleOpen}>
                選擇職業
            </Button>
            <List>
                職業: {selectedProfession ? selectedProfession : "waiting"}
            </List>
            <Dialog fullScreen open={open}>
                <ListItem>
                </ListItem>
                <ListItem>
                    <FrmDialogTest1 />
                </ListItem>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </Dialog>
        </div>
    );
};

export default FrmDialogTest;